import { render, staticRenderFns } from "./UsersBankAccounts.vue?vue&type=template&id=7ca2c535&"
import script from "./UsersBankAccounts.vue?vue&type=script&lang=js&"
export * from "./UsersBankAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports